import { css, Global } from '@emotion/react'

const ToastStyles = () => (
  <Global
    styles={css`
      /* Override React-Toastify styles with Emotion */
      .Toastify__toast-container {
        z-index: 10000;
      }
      .Toastify__toast-container--bottom-right {
        bottom: 1rem;
        right: 1rem;
        left: auto !important;
      }
      .Toastify__toast {
        background-color: #333;
        color: #fff;
        border-radius: 8px;
        padding: 16px;
        font-family: 'Arial', sans-serif;
      }
      .Toastify__toast--success {
        background-color: #000;
        color: #fff;
      }
      .Toastify__toast--error {
        background-color: #f44336;
      }
      .Toastify__toast--info {
        background-color: #2196f3;
      }
      .Toastify__progress-bar {
        background-color: #fff;
      }
    `}
  />
)

export default ToastStyles
